<template>
	<div>
		<n-button type="primary" @click="handleButtonClick">
			{{ text }}
			<template #icon>
				<n-icon><i-carbon-earth-europe-africa-filled /></n-icon>
			</template>
		</n-button>
	</div>
</template>

<script setup>
	import {NButton} from 'naive-ui'
	import {toRefs} from 'vue'
	import ICarbonEarthEuropeAfricaFilled from '~icons/carbon/earth-europe-africa-filled'

	const props = defineProps({
		text: String,
		url: String,
	})
	const {text, url} = toRefs(props)

	function handleButtonClick() {
		fetch('https://www.asiago.it/clienteventslogger.ashx', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				interactionsTypesId: 15,
				content: JSON.stringify({text: text.value, url: url.value}),
				idLingua: WC.idLingua,
				idMenu: WC.idMenu,
				idArticolo: WC.idArticolo,
				idElemento: WC.idCliente,
				url: window.location.href,
				screenResolution:
					window.screen.width && window.screen.height
						? window.screen.width + 'x' + window.screen.height
						: null,
			}),
		})
		window.open(url.value, '_blank')
	}
</script>
